import { components } from "@apiUtils/schema-staff";

// Helper function to fetch the message count
async function fetchMessageCount() {
  const response = await fetch("/api/notification/count/?status=unread", {
    headers: { "Content-Type": "application/json" },
  });

  if (response.ok) {
    const data = (await response.json()) as components["schemas"]["NotificationCount"];
    return data.count;
  }
}

/** This async generator is used to fetch the count of unread message from staff user's inbox
 *  It runs every 10 minutes to keep the count updated.
 *
 *  Since we are still not rendering Staff App as a true SPA, we need to store the last time we fetched the count
 *  in sessionStorage to avoid fetching the count on every page load.
 *  - If the last time we fetched the count is greater than 10 minutes, we fetch the count immediately.
 *  - If the last time we fetched the count is less than 10 minutes, we set a timeout to fetch the count
 *    after the remaining time.
 */
async function* inboxMessageCountGenerator() {
  const POLLING_INTERVAL = 600000; // 10 minutes
  const lastMessageCountTime = Number.parseInt(
    sessionStorage.getItem("lastMessageCountTime") || "0",
    10
  );
  const timeToLastCheckCount = Date.now() - lastMessageCountTime;

  // Check if initial delay is needed
  if (timeToLastCheckCount < POLLING_INTERVAL) {
    await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL - timeToLastCheckCount));
  }

  while (true) {
    const count = await fetchMessageCount();
    sessionStorage.setItem("lastMessageCountTime", Date.now().toString());
    yield count;
    // wait 10 minutes before yielding the next count
    await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL));
  }
}

export { inboxMessageCountGenerator, fetchMessageCount };
